import permissions from 'constants/permissions'

const DATA_PROCESS_TEMPLATE_LIST = [
  {
    name: 'Visualizar',
    tag: permissions.DATA_PROCESS_TEMPLATE.VIEW,
  },
  {
    name: 'Gerenciar',
    tag: permissions.DATA_PROCESS_TEMPLATE.MANAGE,
  },
]

export default DATA_PROCESS_TEMPLATE_LIST
